export function saveByteArray(reportName: string, array: Uint8Array) {
  const blob = new Blob([array], { type: 'application/pdf' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  const fileName = reportName
  link.download = fileName
  link.click()
}
